export default __webpack_public_path__ + "static/media/icon_intelligence_linguistic.15f2ca9d.svg";